import React from 'react';

function cardinal(deg) {
  const dirs = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
  return dirs[Math.round(deg / 22.5) % 16];
}

function formatRange(nm) {
  if (nm < 1) return `${Math.round(nm * 1852)} m`;
  return `${nm.toFixed(1)} nm`;
}

/**
 * Shared marina/POI popup body — phone, VHF, address from ActiveCaptain lookup.
 */
export default function PoiDetailsContent({
  name,
  categoryLabel,
  emoji = '📍',
  operator,
  rating,
  extraRating,
  fuelTypes,
  address,
  phone,
  website,
  vhf,
  notes,
  distanceNm,
  bearingDeg: brg,
  loading = false,
  unavailable = false,
}) {
  return (
    <div style={{ minWidth: 200 }}>
      <div style={{ fontWeight: 700, fontSize: '0.95rem' }}>
        {emoji} {name || 'Place'}
      </div>
      {categoryLabel && (
        <div style={{ color: '#6b7280', fontSize: '0.78rem', marginBottom: 4 }}>
          {categoryLabel}
          {operator ? ` · ${operator}` : ''}
          {rating != null && ` · ★ ${Number(rating).toFixed(1)}`}
          {extraRating != null && rating == null && ` · ★ ${Number(extraRating).toFixed(1)}`}
        </div>
      )}

      {distanceNm != null && brg != null && (
        <div style={{ fontWeight: 600, margin: '4px 0' }}>
          {formatRange(distanceNm)} away · {Math.round(brg)}° {cardinal(brg)} from your boat
        </div>
      )}

      {fuelTypes?.length > 0 && (
        <div style={{ margin: '4px 0' }}>
          {fuelTypes.map((f) => (
            <span
              key={f}
              style={{
                display: 'inline-block', padding: '1px 8px', marginRight: 4,
                borderRadius: 10, fontSize: '0.72rem', fontWeight: 600,
                background: f === 'diesel' ? '#fef3c7' : '#dbeafe',
                color: f === 'diesel' ? '#92400e' : '#1e40af',
              }}
            >
              {f}
            </span>
          ))}
        </div>
      )}

      {address && <div style={{ fontSize: '0.8rem' }}>{address}</div>}
      {vhf && <div style={{ fontSize: '0.8rem' }}>📻 VHF {vhf}</div>}
      {phone && (
        <div style={{ fontSize: '0.8rem' }}>
          📞 <a href={`tel:${phone}`}>{phone}</a>
        </div>
      )}
      {website && (
        <div style={{ fontSize: '0.8rem' }}>
          🔗 <a href={website} target="_blank" rel="noopener noreferrer">Website</a>
        </div>
      )}
      {notes?.length > 0 && (
        <div style={{ fontSize: '0.75rem', color: '#4b5563', marginTop: 4 }}>
          {notes.map((n, i) => (
            <div key={i}>{n}</div>
          ))}
        </div>
      )}
      {loading && (
        <div style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: 4 }}>Looking up contact details…</div>
      )}
      {unavailable && !phone && !vhf && !address && (
        <div style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: 4 }}>
          No contact details on file for this location.
        </div>
      )}
    </div>
  );
}
